module.exports = __webpack_public_path__ + "img/cloud_tool_rda.c735276c.jpg";